import { IAutoMapper } from "../core/automapper/interfaces";
import { HomePages } from "../platform/modules/user/login-landing-page/homepages.model";
import { StringHelper } from "../utilities/contracts/string-helper";

export const mapUserToken = (automapper: IAutoMapper): void => {

  automapper
    .createMap("default", "UserToken")
    .forMember("token", o => o.token)
    .forMember("communicationMsBaseUrl", o => o.communicationMsBaseUrl)
    .forMember("concordFaxUserName", o => o.concordFaxUserName)
    .forMember("coRetrievalOrganization", o => o.coRetrievalOrganization)
    .forMember("defaultRole", o => o.defaultRole)
    .forMember("directoryRoleIds", o => o.directoryRoleIds)
    .forMember("displayUserMFAAttribute", o => o.displayUserMFAAttribute)
    .forMember("emailAddress", o => o.emailAddress)
    .forMember("enableAnnotationCopyFeature", o => o.enableAnnotationCopyFeature)
    .forMember("enableChartLakeMatchSection", o => o.enableChartLakeMatchSection)
    .forMember("enableRiskFirstPassBot", o => o.enableRiskFirstPassBot)
    .forMember("enableHedisFirstPassBot", o => o.enableHedisFirstPassBot)
    .forMember("enableThumbnailView", o => o.enableThumbnailView)
    .forMember("firstName", o => o.firstName)
    .forMember("functionalRoleIds", o => o.functionalRoleIds)
    .forMember("homePageUrl", o => o.homePageUrl)
    .forMember("internetSpeedTestFileSize", o => o.internetSpeedTestFileSize)
    .forMember("internetSpeedTestInterval", o => o.internetSpeedTestInterval)
    .forMember("internetSpeedTestMessageCount", o => o.internetSpeedTestMessageCount)
    .forMember("internetSpeedTestThresholdValue", o => o.internetSpeedTestThresholdValue)
    .forMember("isAddTag", o => o.isAddTag)
    .forMember("isAdminRole", o => o.isAdminRole)
    .forMember("isAuth0Enabled", o => o.isAuth0Enabled)
    .forMember("isCommunicationEksEnabled", o => o.isCommunicationEksEnabled)
    .forMember("isCoRetrievalEnabled", o => o.isCoRetrievalEnabled)
    .forMember("isEmployeeRole", o => o.isEmployeeRole)
    .forMember("isLeadRole", o => o.isLeadRole)
    .forMember("isManagerRole", o => o.isManagerRole)
    .forMember("isMDPortalSettingEnabled", o => o.isMDPortalSettingEnabled)
    .forMember("isMFAEnabled", o => o.isMFAEnabled)
    .forMember("isMROIntegrationEnabled", o => o.isMROIntegrationEnabled)
    .forMember("isParentOrg", o => o.isParentOrg)
    .forMember("isPreSignedUrlUploadEnabled", o => o.isPreSignedUrlUploadEnabled)
    .forMember("isReadOnlyErrorMessageSuppressed", o => o.isReadOnlyErrorMessageSuppressed)
    .forMember("isReadOnlyRole", o => o.isReadOnlyRole)
    .forMember("isRemoveTag", o => o.isRemoveTag)
    .forMember("isSsoLoginMandatory", o => o.isSsoLoginMandatory)
    .forMember("isSsoUser", o => o.isSsoUser)
    .forMember("isTagManagement", o => o.isTagManagement)
    .forMember("isTemporaryPassword", o => o.isTemporaryPassword)
    .forMember("isUserMFAEnabled", o => o.isUserMFAEnabled)
    .forMember("isViewInvoicePermission", o => o.isViewInvoicePermission)
    .forMember("lastName", o => o.lastName)
    .forMember("organizationId", o => o.organizationId)
    .forMember("organizationName", o => o.organizationName)
    .forMember("phoneNumber", o => o.phoneNumber)
    .forMember("primaryUserRoleId", o => o.primaryUserRoleId)
    .forMember("providerPacketLogoUploadSizeInBytes", o => o.providerPacketLogoUploadSizeInBytes)
    .forMember("sessionId", o => o.sessionId)
    .forMember("userHomePagesOptions", o => o.userHomePagesOptions)
    .forMember("userId", o => o.userId)
    .forMember("username", o => o.userName)
    .forMember("userOnboardingUrl", o => o.userOnboardingUrl);
};

export class UserToken {
  readonly token: string;
  communicationMsBaseUrl: string;
  concordFaxUserName: string;
  coRetrievalOrganization: string;
  defaultRole: string;
  directoryRoleIds: number[];
  displayUserMFAAttribute: boolean;
  emailAddress: string;
  enableAnnotationCopyFeature: boolean;
  enableChartLakeMatchSection: boolean;
  enableRiskFirstPassBot: boolean;
  enableHedisFirstPassBot: boolean;
  enableThumbnailView: boolean;
  firstName: string;
  functionalRoleIds: number[];
  homePageUrl: string;
  internetSpeedTestFileSize: number;
  internetSpeedTestInterval: number;
  internetSpeedTestMessageCount: number;
  internetSpeedTestThresholdValue: number;
  isAddTag: boolean;
  isAdminRole: boolean;
  isAuth0Enabled: boolean;
  isCommunicationEksEnabled: boolean;
  isCoRetrievalEnabled: boolean;
  isEmployeeRole: boolean;
  isLeadRole: boolean;
  isManagerRole: boolean;
  isMDPortalSettingEnabled: boolean;
  isMFAEnabled: boolean;
  isMROIntegrationEnabled: boolean;
  isParentOrg: boolean;
  isPreSignedUrlUploadEnabled: boolean;
  isReadOnlyErrorMessageSuppressed: boolean;
  isReadOnlyRole: boolean;
  isRemoveTag: boolean;
  isSsoLoginMandatory: boolean;
  isSsoUser: boolean;
  isTagManagement: boolean;
  isTemporaryPassword: boolean;
  isUserMFAEnabled: boolean;
  isViewInvoicePermission: boolean;
  lastName: string;
  organizationId: number;
  organizationName: string;
  phoneNumber: string;
  primaryUserRoleId: string;
  providerPacketLogoUploadSizeInBytes?: number;
  sessionId: string;
  userHomePagesOptions: HomePages;
  userId: number;
  username: string;
  userOnboardingUrl: string;

  constructor(options: Partial<UserToken> = {}) {
    this.communicationMsBaseUrl = StringHelper.clean(options.communicationMsBaseUrl);
    this.concordFaxUserName = options.concordFaxUserName;
    this.coRetrievalOrganization = options.coRetrievalOrganization;
    this.defaultRole = options.defaultRole;
    this.directoryRoleIds = options.directoryRoleIds;
    this.displayUserMFAAttribute = options.displayUserMFAAttribute;
    this.emailAddress = options.emailAddress;
    this.enableAnnotationCopyFeature = options.enableAnnotationCopyFeature;
    this.enableChartLakeMatchSection = options.enableChartLakeMatchSection;
    this.enableRiskFirstPassBot = options.enableRiskFirstPassBot;
    this.enableHedisFirstPassBot = options.enableHedisFirstPassBot;
    this.enableThumbnailView = options.enableThumbnailView;
    this.firstName = options.firstName;
    this.functionalRoleIds = options.functionalRoleIds;
    this.homePageUrl = options.homePageUrl;
    this.internetSpeedTestFileSize = options.internetSpeedTestFileSize;
    this.internetSpeedTestInterval = options.internetSpeedTestInterval;
    this.internetSpeedTestMessageCount = options.internetSpeedTestMessageCount;
    this.internetSpeedTestThresholdValue = options.internetSpeedTestThresholdValue;
    this.isAddTag = options.isAddTag;
    this.isAdminRole = options.isAdminRole;
    this.isAuth0Enabled = options.isAuth0Enabled;
    this.isCommunicationEksEnabled = options.isCommunicationEksEnabled;
    this.isCoRetrievalEnabled = options.isCoRetrievalEnabled;
    this.isEmployeeRole = options.isEmployeeRole;
    this.isLeadRole = options.isLeadRole;
    this.isManagerRole = options.isManagerRole;
    this.isMDPortalSettingEnabled = options.isMDPortalSettingEnabled;
    this.isMROIntegrationEnabled = options.isMROIntegrationEnabled;
    this.isMFAEnabled = options.isMFAEnabled;
    this.isMROIntegrationEnabled = options.isMROIntegrationEnabled;
    this.isParentOrg = options.isParentOrg;
    this.isPreSignedUrlUploadEnabled = options.isPreSignedUrlUploadEnabled;
    this.isReadOnlyErrorMessageSuppressed = options.isReadOnlyErrorMessageSuppressed;
    this.isReadOnlyRole = options.isReadOnlyRole;
    this.isRemoveTag = options.isRemoveTag;
    this.isSsoLoginMandatory = options.isSsoLoginMandatory;
    this.isSsoUser = options.isSsoUser;
    this.isTagManagement = options.isTagManagement;
    this.isTemporaryPassword = options.isTemporaryPassword;
    this.isUserMFAEnabled = options.isUserMFAEnabled;
    this.isViewInvoicePermission = options.isViewInvoicePermission;
    this.lastName = options.lastName;
    this.organizationId = options.organizationId;
    this.organizationName = options.organizationName;
    this.phoneNumber = options.phoneNumber;
    this.primaryUserRoleId = StringHelper.clean(options.primaryUserRoleId);
    this.providerPacketLogoUploadSizeInBytes = options.providerPacketLogoUploadSizeInBytes;
    this.sessionId = StringHelper.clean(options.sessionId);
    this.token = options.token;
    this.userHomePagesOptions = options.userHomePagesOptions;
    this.userId = options.userId;
    this.username = StringHelper.clean(options.username);
    this.userOnboardingUrl = StringHelper.clean(options.userOnboardingUrl);
  }

  get isAuthenticated(): boolean {
    return StringHelper.isAvailable(this.username);
  }

  get isUserMangerAdminLead(): boolean {
    return (this.isManagerRole || this.isAdminRole || this.isLeadRole);
  }
}
